import { AuditCard } from "@/features/Audit/AuditCard";
import { useParams } from "react-router-dom";
import { StockExchangeEditCard } from "./edit_card";

const client = "instit-quantilia";
const table_name = "stock_exchanges";

export const StockExchangeCard = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>Invalid Code</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <StockExchangeEditCard
          code={id}
          client={client}
          table_name={table_name}
        />
        <AuditCard id={id} client={client} audit_table_name={table_name} />
      </div>
    </div>
  );
};
